/**
 * SPDX-FileCopyrightText: © 2014 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: LGPL-3.0-or-later
 */

import ButtonAccessibilityImageAlt from './button-accessibility-image-alt.jsx';
import ButtonBackgroundColor from './button-background-color.jsx';
import ButtonBold from './button-bold.jsx';
import ButtonCameraImage from './button-camera-image.jsx';
import ButtonCamera from './button-camera.jsx';
import ButtonCode from './button-code.jsx';
import ButtonColor from './button-color.jsx';
import ButtonCommandListItem from './button-command-list-item.jsx';
import ButtonCommandsList from './button-commands-list.jsx';
import ButtonDropdown from './button-dropdown.jsx';
import ButtonEmbedEdit from './button-embed-edit.jsx';
import ButtonEmbedVideoEdit from './button-embed-video-edit.jsx';
import ButtonEmbedVideo from './button-embed-video.jsx';
import ButtonEmbed from './button-embed.jsx';
import ButtonH1 from './button-h1.jsx';
import ButtonH2 from './button-h2.jsx';
import ButtonHline from './button-hline.jsx';
import ButtonImageAlignCenter from './button-image-align-center.jsx';
import ButtonImageAlignLeft from './button-image-align-left.jsx';
import ButtonImageAlignRight from './button-image-align-right.jsx';
import ButtonImage from './button-image.jsx';
import ButtonIndentBlock from './button-indent-block.jsx';
import ButtonItalic from './button-italic.jsx';
import ButtonItemSelectorAudio from './button-item-selector-audio.jsx';
import ButtonItemSelectorImage from './button-item-selector-image.jsx';
import ButtonItemSelectorVideo from './button-item-selector-video.jsx';
import ButtonLinkAutocompleteList from './button-link-autocomplete-list.jsx';
import ButtonLinkBrowse from './button-link-browse.jsx';
import ButtonLinkEditBrowse from './button-link-edit-browse.jsx';
import ButtonLinkEdit from './button-link-edit.jsx';
import ButtonLinkTargetEdit from './button-link-target-edit.jsx';
import ButtonLink from './button-link.jsx';
import ButtonOl from './button-ol.jsx';
import ButtonOutdentBlock from './button-outdent-block.jsx';
import ButtonParagraphAlignLeft from './button-paragraph-align-left.jsx';
import ButtonParagraphAlignRight from './button-paragraph-align-right.jsx';
import ButtonParagraphAlign from './button-paragraph-align.jsx';
import ButtonParagraphCenter from './button-paragraph-center.jsx';
import ButtonParagraphJustify from './button-paragraph-justify.jsx';
import ButtonQuote from './button-quote.jsx';
import ButtonRemoveFormat from './button-remove-format.jsx';
import ButtonRemoveImage from './button-remove-image.jsx';
import ButtonSeparator from './button-separator.jsx';
import ButtonSpacing from './button-spacing.jsx';
import ButtonStrike from './button-strike.jsx';
import ButtonStylesListHeader from './button-styles-list-header.jsx';
import ButtonStylesListItemRemove from './button-styles-list-item-remove.jsx';
import ButtonStylesListItem from './button-styles-list-item.jsx';
import ButtonStylesList from './button-styles-list.jsx';
import ButtonStyles from './button-styles.jsx';
import ButtonSubscript from './button-subscript.jsx';
import ButtonSuperscript from './button-superscript.jsx';
import ButtonTableCell from './button-table-cell.jsx';
import ButtonTableColumn from './button-table-column.jsx';
import ButtonTableEdit from './button-table-edit.jsx';
import ButtonTableHeading from './button-table-heading.jsx';
import ButtonTableRemove from './button-table-remove.jsx';
import ButtonTableRow from './button-table-row.jsx';
import ButtonTable from './button-table.jsx';
import ButtonTargetList from './button-target-list.jsx';
import ButtonTwitter from './button-twitter.jsx';
import ButtonUl from './button-ul.jsx';
import ButtonUnderline from './button-underline.jsx';

export default {
	[ButtonAccessibilityImageAlt.key]: ButtonAccessibilityImageAlt,
	[ButtonBackgroundColor.key]: ButtonBackgroundColor,
	[ButtonBold.key]: ButtonBold,
	[ButtonCameraImage.key]: ButtonCameraImage,
	[ButtonCamera.key]: ButtonCamera,
	[ButtonCode.key]: ButtonCode,
	[ButtonColor.key]: ButtonColor,
	[ButtonCommandListItem.key]: ButtonCommandListItem,
	[ButtonCommandsList.key]: ButtonCommandsList,
	[ButtonDropdown.key]: ButtonDropdown,
	[ButtonEmbedEdit.key]: ButtonEmbedEdit,
	[ButtonEmbed.key]: ButtonEmbed,
	[ButtonEmbedVideoEdit.key]: ButtonEmbedVideoEdit,
	[ButtonEmbedVideo.key]: ButtonEmbedVideo,
	[ButtonH1.key]: ButtonH1,
	[ButtonH2.key]: ButtonH2,
	[ButtonHline.key]: ButtonHline,
	[ButtonImageAlignCenter.key]: ButtonImageAlignCenter,
	[ButtonImageAlignLeft.key]: ButtonImageAlignLeft,
	[ButtonImageAlignRight.key]: ButtonImageAlignRight,
	[ButtonImage.key]: ButtonImage,
	[ButtonIndentBlock.key]: ButtonIndentBlock,
	[ButtonItalic.key]: ButtonItalic,
	[ButtonItemSelectorAudio.key]: ButtonItemSelectorAudio,
	[ButtonItemSelectorImage.key]: ButtonItemSelectorImage,
	[ButtonItemSelectorVideo.key]: ButtonItemSelectorVideo,
	[ButtonLinkAutocompleteList.key]: ButtonLinkAutocompleteList,
	[ButtonLinkBrowse.key]: ButtonLinkBrowse,
	[ButtonLinkEditBrowse.key]: ButtonLinkEditBrowse,
	[ButtonLinkEdit.key]: ButtonLinkEdit,
	[ButtonLinkTargetEdit.key]: ButtonLinkTargetEdit,
	[ButtonLink.key]: ButtonLink,
	[ButtonOl.key]: ButtonOl,
	[ButtonOutdentBlock.key]: ButtonOutdentBlock,
	[ButtonParagraphAlign.key]: ButtonParagraphAlign,
	[ButtonParagraphAlignLeft.key]: ButtonParagraphAlignLeft,
	[ButtonParagraphAlignRight.key]: ButtonParagraphAlignRight,
	[ButtonParagraphCenter.key]: ButtonParagraphCenter,
	[ButtonParagraphJustify.key]: ButtonParagraphJustify,
	[ButtonQuote.key]: ButtonQuote,
	[ButtonRemoveFormat.key]: ButtonRemoveFormat,
	[ButtonRemoveImage.key]: ButtonRemoveImage,
	[ButtonSeparator.key]: ButtonSeparator,
	[ButtonSpacing.key]: ButtonSpacing,
	[ButtonStrike.key]: ButtonStrike,
	[ButtonStylesListHeader.key]: ButtonStylesListHeader,
	[ButtonStylesListItemRemove.key]: ButtonStylesListItemRemove,
	[ButtonStylesListItem.key]: ButtonStylesListItem,
	[ButtonStylesList.key]: ButtonStylesList,
	[ButtonStyles.key]: ButtonStyles,
	[ButtonSubscript.key]: ButtonSubscript,
	[ButtonSuperscript.key]: ButtonSuperscript,
	[ButtonTableCell.key]: ButtonTableCell,
	[ButtonTableColumn.key]: ButtonTableColumn,
	[ButtonTableEdit.key]: ButtonTableEdit,
	[ButtonTableHeading.key]: ButtonTableHeading,
	[ButtonTableRemove.key]: ButtonTableRemove,
	[ButtonTableRow.key]: ButtonTableRow,
	[ButtonTable.key]: ButtonTable,
	[ButtonTargetList.key]: ButtonTargetList,
	[ButtonTwitter.key]: ButtonTwitter,
	[ButtonUl.key]: ButtonUl,
	[ButtonUnderline.key]: ButtonUnderline,
};
